var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.2 9.605V4H7.8v5.605A4.005 4.005 0 0 0 4 13.6v9.6h3.4v-1.6H5.6v-8A2.403 2.403 0 0 1 8 11.2h16a2.403 2.403 0 0 1 2.4 2.4v8h-2.2v1.6H28v-9.6a4.005 4.005 0 0 0-3.8-3.995ZM22.6 9.6H9.4v-4h13.2v4Z",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.6 13.203H23v1.6h1.6v-1.6ZM9 16.398H7v1.6h2v10h13.6v-10h2v-1.6H9Zm12 10H10.6v-8.4H21v8.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.c2d21ae55f8e61d3acd696398d7d3950.svg";
export { ForwardRef as ReactComponent };